<template>
  <div class="addAccountingComputerizationNotice">
    <div class="newsDetial-header">
      <div class="newsDetial-title">新建内容</div>
      <blank height="15"> </blank>
      <div class="newsDetial-abstract">请按照表单要求添加和修改数据</div>
      <blank height="45"> </blank>
    </div>
    <div class="detial-cont">
      <div class="detial-cont-title">基本信息</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-descriptions layout="vertical">
          <a-descriptions-item>
            <span slot="label">部门/单位<span class="required">*</span></span>
            <a-tooltip placement="topLeft" :title="Form.organizationName">
              <div>
                <a-input
                  v-if="id"
                  class="w300"
                  placeholder="请添加"
                  v-model="Form.organizationoneName"
                  disabled
                />
                <a-select
                  v-else
                  class="w300"
                  placeholder="请选择"
                  v-model="Form.organizationid"
                >
                  <a-select-option
                    v-for="item in organizationUserList"
                    :value="item.organizationId"
                    :key="item.organizationId"
                  >
                    {{ item.organizationname }}</a-select-option
                  >
                </a-select>
              </div>
            </a-tooltip>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label">预约人<span class="required">*</span> </span>
            <a-select
              placeholder="请添加"
              :disabled="id != ''"
              class="w300"
              v-model="Form.peopleId"
            >
              <a-select-option
                v-for="i in queryUserList"
                :value="i.id"
                :key="i.id"
                >{{ i.fullName }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>

          <a-descriptions-item label="申请时间">
            <a-date-picker
              show-time
              class="w300"
              valueFormat="YYYY-MM-DD HH:mm:ss"
              v-model="Form.applyTime"
              :disabled="id != ''"
            />
          </a-descriptions-item>
          <a-descriptions-item label="手机号码"
            ><a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.mobilePhone"
              @change="eightyfive('mobilePhone')"
              :disabled="id != ''"
            />
          </a-descriptions-item>
          <a-descriptions-item label="预约方式">
            <a-select
              placeholder="请添加"
              disabled
              class="w300"
              v-model="Form.type"
            >
              <a-select-option :value="0">自助预约</a-select-option>
              <a-select-option :value="1">代客预约</a-select-option>
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item v-if="Form.type == 1">
            <span slot="label">经办人<span class="required">*</span> </span>
            <a-select
              placeholder="请添加"
              class="w300"
              v-model="Form.peopleId"
              disabled
            >
              <a-select-option
                v-for="i in queryUserList"
                :value="i.id"
                :key="i.id"
                >{{ i.fullName }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </div>
    <div class="detial-cont">
      <div class="detial-cont-title">预约信息</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-descriptions layout="vertical">
          <a-descriptions-item>
            <span slot="label"
              >预约部门/单位<span class="required">*</span></span
            >
            <a-tooltip placement="topLeft" :title="Form.organizationName">
              <div>
                <a-input
                  :disabled="id != ''"
                  v-if="id"
                  class="w300"
                  placeholder="请添加"
                  v-model="Form.organizationtwoName"
                />
                <a-select
                  v-else
                  class="w300"
                  placeholder="请选择"
                  v-model="Form.organizationId"
                  @change="getDate"
                >
                  <a-select-option
                    v-for="item in GroupList"
                    :value="item.organizationId"
                    :key="item.organizationId"
                  >
                    {{ item.organizationName }}</a-select-option
                  >
                </a-select>
              </div>
            </a-tooltip>
          </a-descriptions-item>

          <a-descriptions-item label="预约时间">
            <a-input
              :disabled="id != ''"
              v-if="id"
              class="w150"
              placeholder="请添加"
              v-model="Form.makeDate"
            />
            <a-select
              v-else
              class="w150"
              @change="makeDateChange"
              placeholder="请选择"
              v-model="Form.makeDate"
            >
              <a-select-option
                v-for="item in daetList"
                :value="item.makeDate"
                :key="item.makeDate"
              >
                {{ item.makeDate }}</a-select-option
              >
            </a-select>
            <a-input
              :disabled="id != ''"
              v-if="id"
              class="w150"
              placeholder="请添加"
              v-model="Form.officePhaseAns"
            />
            <a-select
              v-else
              class="w150"
              placeholder="请选择"
              v-model="Form.reservationFormId"
              @change="reservationChage"
            >
              <a-select-option
                v-for="item in dayList"
                :value="item.id"
                :key="item.id"
                :name="item.makeReservation"
              >
                {{ item.office }} {{ item.startTime }}—{{
                  item.endTime
                }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item label="预约事由"
            ><a-input
              disabled
              class="w300"
              placeholder="请添加"
              v-model="Form.reason"
              @change="eightyfive('reason')"
            />
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </div>
    <div class="detial-cont" v-if="id">
      <div class="detial-cont-title">办理信息</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <div class="role-formCont">
          <span class="w80 rightAlgin mr20">办理人:</span>
          <a-input
            class="w300"
            placeholder="请添加"
            v-model="Form.handleName"
            @change="eightyfive('handleName')"
            :disabled="!(id && manage == 1 && Form.state == 0)"
          />
        </div>
        <blank height="20"> </blank>
        <div class="role-formCont">
          <span class="w80 rightAlgin mr20">办理状态:</span>
          {{ Form.state == 1 ? "已办理" : "待办理" }}
        </div>
        <blank height="20"> </blank>
        <div class="role-formCont">
          <span class="w80 rightAlgin">办理备注:</span>
          <a-textarea
            :disabled="!(id && manage == 1 && Form.state == 0)"
            class="w500 ml20"
            placeholder="请输入办理备注"
            v-model="Form.note"
            :rows="3"
          />
        </div>
      </div>
    </div>
    <bottomSuspension>
      <a-button :style="{ marginRight: '20px' }" @click="goback">
        返回
      </a-button>
      <a-button
        v-if="id && manage == 1 && Form.state == 0"
        :loading="loading && draft == 1"
        type="primary"
        class="orange-btn"
        @click="preserveFn"
        :style="{ marginRight: '20px' }"
      >
        办理
      </a-button>
      <a-button
        v-if="id == ''"
        :loading="loading && draft == 2"
        type="primary"
        :style="{ marginRight: '20px' }"
        @click="submitFn"
      >
        提交
      </a-button>
    </bottomSuspension>
  </div>
</template>

<script>
import {
  ReservationFormUserlist,
  ReservationFormDatelist,
  sheetsave,
  getsheet,
  updatesheet,
} from "./api/api";
import { mapState, mapActions } from "vuex";
import AccessoriesTable from "@/components/accessories-table/index.vue";
export default {
  components: {
    AccessoriesTable,
  },
  data() {
    return {
      loading: false,
      Form: {},
      id: "",
      dateFormat: "YYYY-MM-DD",
      GroupList: [], // 预约科室
      daetList: [],
      dayList: [],
      manage: "", //是否是来办理
      draft: 1,
    };
  },
  computed: {
    ...mapState({
      organizationUserList: (state) => state.app.organizationUserList, // 当前用户可选部门
      queryUserList: (state) => state.app.queryUserList, // 用户列表
    }),
  },
  created() {
    this.getorganizationUserList();
    this.getqueryUserList();

    //  科室

    ReservationFormUserlist().then((res) => {
      if (res.data.code == 0) {
        this.GroupList = res.data.data;
      }
    });
  },
  mounted() {
    this.id = this.$route.query.id ? this.$route.query.id : "";
    if (this.id) {
      this.manage = this.$route.query.manage ? this.$route.query.manage : "";
      this.load();
    } else {
      this.Form.type = parseInt(this.$route.query.type);
      this.Form.peopleId = this.$store.state.app.userInfo.id;
      this.Form.agentPeople = this.$store.state.app.userInfo.id;
      this.$set(
        this.Form,
        "organizationid",
        this.$store.state.app.organizationId
      );
    }
  },
  methods: {
    //选择时间  获取事由
    reservationChage(e, b) {
      // console.log(e, b);
      // console.log(b.data.attrs.name);
      this.Form.reason = b.data.attrs.name;
    },
    // 根据选择部门拉时间
    getDate(organization_id) {
      ReservationFormDatelist({ organization_id }).then((res) => {
        if (res.data.code == 0) {
          this.daetList = res.data.data;
        }
      });
    },
    // 根据时间拉号源
    makeDateChange(makeDate) {
      ReservationFormDatelist({
        organization_id: this.Form.organizationId,
        makeDate,
      }).then((res) => {
        if (res.data.code == 0) {
          this.dayList = res.data.data;
        }
      });
    },

    ...mapActions(["getorganizationUserList", "getqueryUserList"]),
    //通过字典值过去字典名
    getByTypeName(value, list) {
      let byType = list.find((item) => {
        return item.valuename == value;
      });
      if (byType) {
        return byType.keyname;
      } else {
        return value;
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    load() {
      // 获取详情
      getsheet({ id: this.id }).then((res) => {
        if (res.data.code == 0) {
          this.Form = res.data.data;
          if (this.Form.officePhase == 1) {
            this.Form.officePhaseAns =
              "全天 " + this.Form.startTime + "-" + this.Form.endTime;
          }
          if (this.Form.officePhase == 2) {
            this.Form.officePhaseAns =
              "上午 " + this.Form.startTime + "-" + this.Form.endTime;
          }
          if (this.Form.officePhase == 3) {
            this.Form.officePhaseAns =
              "下午 " + this.Form.startTime + "-" + this.Form.endTime;
          }
        }
      });
    },

    goback() {
      this.$router.push("/BookingManagement");
    },
    preserveFn() {
      let qdata = {};
      qdata.id = this.Form.id;
      qdata.agentPeople = this.Form.agentPeople;
      qdata.handleName = this.Form.handleName;
      qdata.note = this.Form.note;
      qdata.state = 1;
      this.draft = 2;
      this.loading = true;
      updatesheet(qdata).then((res) => {
        this.loading = false;
        if (res.data.code == 0) {
          this.$message.success("办理成功");
          this.$router.push("/reservationList");
        }
      });
    },

    submitFn() {
      if (!this.Form.organizationId) {
        this.$message.error("请添加部门");
        return false;
      }
      this.draft = 1;
      this.loading = true;
      sheetsave(this.Form).then((res) => {
        if (res.data.code == 0) {
          this.$message.success("预约成功");
          this.$router.push("/MyReservation");
          this.loading = false;
        } else {
          this.loading = false;
        }
      });
    },
    // 输入框限制85
    eightyfive(v) {
      if (this.Form[v].length > 85) {
        this.Form[v] = this.Form[v].substring(0, 85);
        this.$message.destroy();
        this.$message.warning("只能输入85个字");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.edui-default {
  width: 857px;
  margin: 0 auto;
}
.addAccountingComputerizationNotice {
  .newsDetial-header {
    position: relative;
    background: #fff;
    padding: 0 40px;
    .newsDetial-title {
      // height: 26px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
    .newsDetial-abstract {
      color: rgba(166, 166, 166, 1);
      font-size: 14px;
      line-height: 22px;
    }
    .detial-top-btn {
      position: absolute;
      right: 87px;
      top: 0;
    }
  }
  .detial-cont {
    margin: 24px 16px;

    .detial-cont-title {
      background: #fff;
      height: 55px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 55px;
      text-align: left;
      padding-left: 32px;
    }
    .detial-cont-view {
      background: #fff;
      padding: 30px;
      .accessory-btn {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .detial-bottom {
    height: 56px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
.whiteSpace {
  white-space: nowrap;
}
// 打印内容不能嵌套写样式
.print-title {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  height: 50px;
  line-height: 50px;
}
.role-formCont {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 10px;
  .role-formlabel {
    width: 120px;
    text-align: right;
    margin-right: 20px;
  }
  .role-formvalue {
    width: calc(100% - 120px);
  }
  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/BookingManagement/detail.vue